import * as columnTranslations from './stringsColumnPlans';
import * as originalTranslations from './strings';

const strings = columnTranslations['en'];
const originalStrings = originalTranslations['en'];

export type FeatureItemType =
  | 'header'
  | 'feature'
  | 'feature_section'
  | 'sub_feature';

export type PlanFeatureItem = {
  type: FeatureItemType;
  text: string;
  variant: boolean;
  emphasisPrefix?: string;
}

const featureItem = (
  text: string,
  type: FeatureItemType,
  variant: boolean,
  emphasisPrefix?: string
): PlanFeatureItem => ({ type, text, variant, emphasisPrefix });

export const getPlanFeatures = ({ planHandle }: { planHandle: string }): PlanFeatureItem[] => {
  switch (planHandle) {
    case 'basic':
    case 'basic_yearly':
      return [
        featureItem(strings.basicHeader, 'header', true),
        featureItem(strings.unlimitedGuests, 'feature', true),
        featureItem(strings.unlimitedProjects, 'feature', true),
        featureItem(strings.aiAgentIntegrations, 'feature', true),
        featureItem(strings.feedbackOnSitesAndFiles, 'feature', true),
        featureItem(strings.screenshotsMetadata, 'feature', true),
        featureItem(strings.textEditsAndVideo, 'feature', true),
        featureItem(strings.collaborationIntegrations, 'feature', true),
        featureItem(strings.publicFeedback, 'feature', true),
      ];
    case 'pro':
    case 'pro_yearly':
      return [
        featureItem(strings.proHeader, 'header', true),
        featureItem(strings.twoWayIntegrations, 'feature', true, '2-way integrations'),
        featureItem(strings.clientCollaborationSection, 'feature_section', true, 'Client collaboration'),
        featureItem(strings.scheduledFeedbackDeadlines, 'sub_feature', true),
        featureItem(strings.customBranding, 'sub_feature', true),
        featureItem(strings.privateTeamComments, 'sub_feature', true),
        featureItem(strings.clientPortal, 'sub_feature', true),
        featureItem(strings.aiAssistedProductivity, 'feature', true, 'AI assisted productivity features'),
        featureItem(strings.apiAccess, 'feature', true, 'API access'),
      ];
    case 'midi':
    case 'standard_yearly':
      return [
        featureItem(originalStrings.unlimitedProjects, 'feature', false),
        featureItem(originalStrings.unlimitedGuests, 'feature', false),
        featureItem(originalStrings.screenshotsExtension, 'feature', false),
        featureItem(originalStrings.annotations, 'feature', false),
        featureItem(originalStrings.intergrations, 'feature', false),
        featureItem(originalStrings.publicFeedback, 'feature', false),
        featureItem(originalStrings.videoFeedback, 'feature', false),
        featureItem(originalStrings.storage10, 'feature', false),
        featureItem(strings.standardHeaderA, 'header', true),
        featureItem(strings.unlimitedGuests, 'feature', true),
        featureItem(strings.unlimitedProjects, 'feature', true),
        featureItem(strings.membersStandard, 'feature', true),
        featureItem(strings.standardHeaderB, 'header', true),
        featureItem(strings.websiteFeedback, 'feature', true),
        featureItem(strings.designFeedback, 'feature', true),
        featureItem(strings.screenshots, 'feature', true),
        featureItem(strings.integrationsStandard, 'feature', true),
        featureItem(strings.publicFeedback, 'feature', true),
        featureItem(strings.videoFeedback, 'feature', true),
        featureItem(strings.storage10, 'feature', true)
      ];
    case 'studio':
    case 'studio_yearly':
      return [
        featureItem(originalStrings.plusStandard, 'feature', false),
        featureItem(strings.studioHeader, 'header', true),
        featureItem(strings.membersStudio, 'feature', true),
        featureItem(strings.storage25, 'feature', true)
      ];
    case 'maxi':
    case 'premium_yearly':
      return [
        featureItem(originalStrings.screenshotsNoExtension, 'feature', false),
        featureItem(originalStrings.premiumIntegrations, 'feature', false),
        featureItem(originalStrings.customBranding, 'feature', false),
        featureItem(originalStrings.guestsSeeGuests, 'feature', false),
        featureItem(originalStrings.membersComment, 'feature', false),
        featureItem(originalStrings.storage50, 'feature', false),
        featureItem(originalStrings.plusStandard, 'feature', false),
        featureItem(strings.premiumHeader, 'header', true),
        featureItem(strings.membersComment, 'feature', true),
        featureItem(strings.customBranding, 'feature', true),
        featureItem(strings.clientProjectBoard, 'feature', true),
        featureItem(strings.guestsSeeGuests, 'feature', true),
        featureItem(strings.premiumIntegrations, 'feature', true),
        featureItem(strings.scheduledFeedbackDeadlines, 'feature', true),
        featureItem(strings.projectFolders, 'feature', true),
        featureItem(strings.storage50, 'feature', true)
      ];
    case 'deluxe':
    case 'deluxe_yearly':
      return [
        featureItem(originalStrings.storage150, 'feature', false),
        featureItem(originalStrings.plusEverythingOnPremium, 'feature', false),
        featureItem(strings.deluxeHeader, 'header', true),
        featureItem(strings.storage150, 'feature', true)
      ];
    case 'freemium':
      return [
        featureItem(originalStrings.creditCardRequired, 'feature', false),
        featureItem(strings.creditCardRequired, 'feature', true)];
    default:
      return [];
  }
};

export const getPlanDescription = ({ planHandle }: { planHandle: string }): string => {
  switch (planHandle) {
    case 'basic':
    case 'basic_yearly':
      return strings.descriptionBasic;
    case 'pro':
    case 'pro_yearly':
      return strings.descriptionPro;
    case 'midi':
    case 'standard_yearly':
      return strings.descriptionStandard;
    case 'studio':
    case 'studio_yearly':
      return strings.descriptionStudio;
    case 'maxi':
    case 'premium_yearly':
      return strings.descriptionPremium;
    case 'deluxe':
    case 'deluxe_yearly':
      return strings.descriptionDeluxe;
    default:
      return '';
  }
};
